import {Provider} from "react-redux";
import {configureStore} from "@reduxjs/toolkit/react";
import {api} from "@/api/api";
import {PropsWithChildren} from "react";
import {setupListeners} from "@reduxjs/toolkit/query/react";
import {poolReducer} from "@/redux/poolSlice.ts"
import {coingeckoApi} from "@/api/chartApi.ts"

const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    [coingeckoApi.reducerPath]: coingeckoApi.reducer,
    pool: poolReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(api.middleware, coingeckoApi.middleware),
});

setupListeners(store.dispatch);

export function AppStoreProvider({children}: PropsWithChildren) {
  return <Provider store={store}>{children}</Provider>;
}

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
